import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, UserService } from '@thiememeulenhoff/ng-security';
import { CommonModule } from '@angular/common';
import { switchMap } from 'rxjs';

@Component({
  imports: [CommonModule, RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  #authService = inject(AuthService);

  #userService = inject(UserService);

  readonly user$ = this.#userService.user$;

  ngOnInit(): void {
    this.#authService
      .login()
      .pipe(switchMap(() => this.#userService.fetchUser()))
      .subscribe();
  }
}
